var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9981 3V5C20.9981 14.627 15.6251 19 8.99807 19H7.09607C7.30807 15.988 8.24607 14.165 10.6941 11.999C11.8981 10.934 11.7961 10.319 11.2031 10.672C7.11907 13.102 5.09007 16.386 5.00007 21.63L4.99707 22H2.99707C2.99707 20.637 3.11307 19.4 3.34307 18.268C3.11374 16.974 2.99874 15.218 2.99807 13C2.99807 7.477 7.47507 3 12.9981 3C14.9981 3 16.9981 4 20.9981 3Z",
    fill: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaf);
export default __webpack_public_path__ + "static/media/releaf.eb19f2192e894b42fa839c610a9cf227.svg";
export { ForwardRef as ReactComponent };